import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { WhiteLabelService } from '@app/core/services/white-label/white-label.service';
import { concatMap, Observable, Subscription } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';

@Component({
    selector: 'app-unauthenticated-layout',
    templateUrl: './unauthenticated-layout.component.html',
    styleUrls: ['./unauthenticated-layout.component.scss'],
    standalone: false,
})
export class UnauthenticatedLayoutComponent implements OnInit, OnDestroy {
    logo$: Observable<string>;
    useBackgroundImage = false;
    routerSubscription: Subscription;

    private whiteBackgroundRoutes = [
        '/login/reset-password',
        '/login/forgot-password',
        '/data-verification-tool/events',
        '/data-verification-tool/reloads',
    ];

    constructor(private whiteLabelService: WhiteLabelService, private router: Router) {
        this.routerSubscription = this.router.events
            .pipe(
                filter((e) => e instanceof NavigationEnd),
                map((e) => e),
                map((e: NavigationEnd) => e.urlAfterRedirects)
            )
            .subscribe((path) => {
                this.useBackgroundImage = !this.whiteBackgroundRoutes.includes(path.split('?')[0]);
            });
    }

    ngOnInit(): void {
        this.logo$ = this.whiteLabelService.domainInfo$.pipe(
            first((domainInfo) => !!domainInfo),
            concatMap((domain) => {
                return this.whiteLabelService.getProviderLogo(domain);
            })
        );
    }

    ngOnDestroy(): void {
        this.routerSubscription.unsubscribe();
    }
}
